import React, {useEffect, useState} from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './ElectionSlider.module.css';

const ElectionSlider = () => {
  const [slides, setSlides] = useState([])

  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      try {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const timestamp = `${hours}${minutes}`;
        const response = await fetch(`/result/ACF2021/json/element356.json?ver=${timestamp}`, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        });
        const data = await response.json();

        const formattedData = data.items.map((item, index) => ({
          title: item.Cand_Name_Malayalam,
          party: item.Party,
          status: item.Status,
          vote: item.Lead_Trail,
          image: `${process.env.PUBLIC_URL}/assets/candidates/${item.Cand_Name_English.trim().toLowerCase().replace(/\s/g, '-').replace(/[^a-z0-9-]/g, '')}.jpg`,
          constituency: item.Const_Name
        }));

        if (isMounted) return (
          setSlides(formattedData)
        )
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    centerMode: false,
    centerPadding: '0',
    focusOnSelect: true,
    variableWidth: true,
    slidesToShow: 2,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 695,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <div className={styles.sliderContainer}>
      <Slider {...settings}>
        {slides.map((slide, index) => {
          const party = slide.party.toLowerCase();
          const status = slide.status.toLowerCase();
          const bgClass = (status === 'lead' || status === 'won') ? styles['lead-bg'] : (status === 'trail' || status === 'lost') ?  styles['trail-bg'] : styles['slide-bg'];
          const statusImage = (status === 'lead' || status === 'won')
            ? <img src={`${process.env.PUBLIC_URL}/assets/lead_r.png`} alt="" />
            : (status === 'trail' || status === 'lost')
              ? <img src={`${process.env.PUBLIC_URL}/assets/trail_r.png`} alt="" />
              : null;

          return (
            <div key={index} className={`${styles.slide} ${bgClass}`}>
              <div className={ styles.slideImageContainer}>
                <img
                  alt=''
                  className={styles.slideImage}
                  style={{ background: `url(${slide.image}) lightgray 50% / cover no-repeat` }}
                />
                {statusImage}
              </div>
              <div className={styles.slideContent}>
                <h4>{slide.title}</h4>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '12px' }}>
                  <span style={{ backgroundColor: `var(--${party}-color)`, color: '#FFF' }}>
                    {slide.party}
                  </span>
                  {slide.constituency}
                </div>
                <p>
                  {slide.status ? (
                    <>
                      {slide.status.toUpperCase()} BY{' '}
                      <span style={{ color: `var(--${status}-color)` }}>
                        {slide.vote}
                      </span>
                    </>
                  ) : null}
                </p>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default  ElectionSlider;
